import initVueApp from "@/core.js";
const component = require(`./../views/ArticleJson.vue`).default;
initVueApp(component);
